export default {
  label: {
    cancelLabel: 'Cancelar',
    cardLabel: 'Remover',
    modalTitle: 'Remover componente',
    modalText: 'Tem certeza que gostaria de remover o componente',
  },
};
